import React, { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Responsive.css";
import "./slide1.css";
import "./slide2.css";
import "./slide3.css";
import { styled } from "@mui/system";
import Textarea from "@mui/joy/Textarea";
import Select, { selectClasses } from "@mui/joy/Select";
import Button from "@mui/joy/Button";
import Option from "@mui/joy/Option";
import Accordion from "react-bootstrap/Accordion";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Input from "@mui/material/Input";
import { Navbar, Nav } from "react-bootstrap";
import FormControl from "@mui/material/FormControl";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Logo from "./images/logo.svg";
import ReverseLogo from "./images/reverse-logo.png";
import AquaImage from "./product-images/aqua-eliza.png";
import StromImage from "./product-images/AQUA_STROM.png";
import innovicaImage from "./product-images/AQUA_INNOVICA.png";
import Aqua2Image from "./product-images/AQUA_2090.png";
import MarseImage from "./product-images/AQUA_MARS.png";
import NineImage from "./product-images/AQUA_NINE.png";
import EquroxImage from "./product-images/EQUROX.png";
import VertexImage from "./product-images/VERTEX.png";
import Vontron_1Image from "./product-images/Domestic_RO_MEMBRANE.png";
import QuickImage from "./product-images/quick-fitting.png";
import Housing from "./product-images/housing.png";
import Zunli from "./product-images/ZUANLI_Diaphragm_Pump.png";
import MembranceHousingImg from "./product-images/MEMBRANE-HOUSING.png";
import PrefilterImages from "./product-images/PRE-FILTER-HOUSING.png";
import FlowRestictor from "./product-images/flow-restictor.png";
import Vontron_2Image from "./product-images/Industrial_RO_MEMBRANE.png";
import Vontron_3Image from "./product-images/PRO_80_Membrane.png";
import FlowsyImage from "./product-images/flowsy.png";
import LedIcon from "./images/digital-led-icon.png";
import BoostIcon from "./images/boost-imun-icon.png";
import CopperIcon from "./images/copper-icon.png";
import Hydromatic_1 from "./product-images/hydromatic.png";
import Hydromatic_2 from "./product-images/Hydromatic_Industrial_RO_MEMBRANE.png";
import NileLogo from './images/nile-logo.png';
import ZuanliLogo from './images/zuanli-logo.png';
import EquroxLogo from './images/equrox.png';
import VontronLogo from './images/vontron.png';
import FlowsyLogo from './images/flowsy-logo.png';
import HydromaticLogo from './images/hydromatic-logo.png';
import MainBanner_2 from './images/main-banner-2.png';
import Bodeer from "./images/Bodeer.png";
import Washable from "./images/washable-pvdf.png";
import Antiscalant from "./images/antiscalant-balls.png";
import TestiProfile1 from "./images/testi-profile.png";
import ReusableSlider from "./ReusableSlider";
import Reusablemulti from "./Reusablemulti";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

function App() {
  const BorderedInput = styled(Input)(
    ({ theme }) =>
      `width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: #000;
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: 0 2px 4px #ccc
    &:hover {
      border-color: #000;
    }
  
    &:focus {
      border-color: #000;
      box-shadow: 0 0 0 3px #cccc;
    }`
  );

  const Section1 = () => {
    const slides = [
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs="12" lg="5">
          <h4>RO Systems</h4>
          <h2 className="slider-head">AQUA Eliza</h2>
          <ul>
            <li>For Counter Top / Wall Mounting</li>
            <li>Purification : RO + UV + Alkaline + Copper + TDS (Optional)</li>
            <li>Digital Display</li>
            <li>Food Grade, Non Breakable, ABS Plastic Construction</li>
            <li>Purification Capacity of 12 to 15 Ltr. / hr.</li>
            <li>Tank Storage Capacity : 10 Ltr. (Approx)</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col xs="12" lg="7">
          <img src={AquaImage} alt="" className="img-fluid product-images" />
        </Col>
      </Row>,
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs="12" lg="5">
          <h4>RO Systems</h4>
          <h2 className="slider-head">AQUA Strom</h2>
          <ul>
            <li>High-flow purification system ideal for larger families.</li>
            <li>Advanced TDS controller for balanced mineral retention.</li>
            <li>Durable body with wall-mount or countertop flexibility.</li>
            <li>Ensures purity with every drop, even in high TDS regions.</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col xs="12" lg="7">
          <img src={StromImage} alt="" className="img-fluid product-images" />
        </Col>
      </Row>,
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs="12" lg="5">
          <h4>RO Systems</h4>
          <h2 className="slider-head">AQUA Innovica</h2>
          <ul>
            <li>Sleek and compact, perfect for urban kitchens.</li>
            <li>Smart LED indicators for filter status and maintenance alerts.</li>
            <li>Energy-efficient design with optimum purification performance.</li>
            <li>Designed for low-water wastage and maximum purity.</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col xs="12" lg="7">
          <img src={innovicaImage} alt="" className="img-fluid product-images" />
        </Col>
      </Row>,
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs="12" lg="5">
          <h4>RO Systems</h4>
          <h2 className="slider-head">AQUA 2090</h2>
          <ul>
            <li>Heavy-duty RO system for homes with high water consumption.</li>
            <li>Multiple purification stages for comprehensive filtration.</li>
            <li>High-capacity storage tank with quick recovery rate.</li>
            <li>Advanced RO technology with Copper + Alkaline filtration for pure & mineral-rich water.</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col xs="12" lg="7">
          <img src={Aqua2Image} alt="" className="img-fluid product-images" />
        </Col>
      </Row>,
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs="12" lg="5">
          <h4>RO Systems</h4>
          <h2 className="slider-head">AQUA Mars</h2>
          <ul>
            <li>Combines style with superior purification technology.</li>
            <li>Retains essential minerals with advanced TDS regulation.</li>
            <li>Safe for borewell, tanker, and municipal water sources.</li>
            <li>Ideal for both residential and light commercial use.</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col xs="12" lg="7">
          <img src={MarseImage} alt="" className="img-fluid product-images" />
        </Col>
      </Row>,
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs="12" lg="5">
          <h4>RO Systems</h4>
          <h2 className="slider-head">AQUA Nine</h2>
          <ul>
            <li>Compact and robust design with smart purification layers.</li>
            <li>Delivers safe, odor-free, and great-tasting water.</li>
            <li>Built-in pre-filter and mineral enhancer functionality.</li>
            <li>Reliable choice for everyday healthy hydration. </li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col xs="12" lg="7">
          <img src={NineImage} alt="" className="img-fluid product-images" />
        </Col>
      </Row>
    ];
    return <ReusableSlider data={slides} className="section1-slider" />;
  };

  const Section2 = () => {
    const slides = [
      <Row >
        <Col>
          <img src={FlowsyImage} alt="" className="flosy-img img-fluid product-images" />
        </Col>
        <Col xs="12" lg="5">
          <h4>DIAPHRAGM PUMP</h4>
          <h2 className="slider-head">Flowsy</h2>
          <ul>
            <li>Ideal for 75 GPD domestic RO systems.</li>
            <li>Provides stable and silent performance
            </li>
            <li>Features low heat generation for extended lifespan</li>
            <li>Compact and energy-efficient design with high reliability.</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" className="img-fluid" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" className="img-fluid" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" className="img-fluid" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
      </Row>,
      <Row >
        <Col xs="12" lg="7">
          <img src={EquroxImage} className="flosy-img img-fluid product-images" alt="" />
        </Col>
        <Col xs="12" lg="5">
          <h4>DIAPHRAGM PUMP</h4>
          <h2 className="slider-head">EQUROX</h2>
          <ul>
            <li>Operates with zero noise for a silent experience.</li>
            <li>Provides excellent and stable pressure output.</li>
            <li>Engineered for the lowest vibration during use.</li>
            <li>Generates minimal heat for better efficiency.</li>
            <li>Built for long-lasting, reliable performance.</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
      </Row>,
      <Row >
        <Col xs="12" lg="7">
          <img src={VertexImage} className="flosy-img img-fluid product-images" alt="" />
        </Col>
        <Col xs="12" lg="5">
          <h4>DIAPHRAGM PUMP</h4>
          <h2 className="slider-head">VERTEX</h2>
          <ul>
            <li>India’s First Low-Budget Imported Pump</li>
            <li>18-Month Piece-to-Piece Warranty</li>
            <li>100 GPD Flow Capacity</li>
            <li>Minimal Heat Generation</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
      </Row>,
      <Row >
        <Col xs="12" lg="7">
          <img src={Zunli} className="flosy-img img-fluid product-images" alt="" />
        </Col>
        <Col xs="12" lg="5">
          <h4>DIAPHRAGM PUMP</h4>
          <h2 className="slider-head">ZUANLI</h2>
          <ul>
            <li>Trusted imported pump with consistent pressure output</li>
            <li>Designed for low noise and minimal vibration operation</li>
            <li>Built for long-term durability in residential RO systems</li>
            <li>Efficient 24V DC performance with stable flow control</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
          </div>
        </Col>
      </Row>,
    ];
    return <ReusableSlider data={slides} className="section2-slider" />;
  };

  const Section3 = () => {
    const slides = [

      <Row className="flex-column-reverse flex-lg-row">
        <Col xs lg="6">
          <h4>RO MEMBRANE</h4>
          <h2 className="slider-head">Hydromatic</h2>
          <p>75/80/100/300 GPD</p>
          <Table className="product-dsc-table">
            <TableHead>
              <TableRow>
                <TableCell className="custom-table-head" rowSpan={2}>
                  <b>Product</b>
                </TableCell>
                <TableCell
                  className="custom-table-head"
                  colSpan={2}
                  align="center"
                >
                  <b>Performance</b>
                </TableCell>
                <TableCell
                  className="custom-table-head"
                  colSpan={5}
                  align="center"
                >
                  <b>Test Conditions</b>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="custom-table-head">
                  Permeate flow rate (GPD)
                </TableCell>
                <TableCell className="custom-table-head">
                  Typical salt rejection (%)
                </TableCell>
                <TableCell className="custom-table-head">
                  NaCl Conc (ppm)
                </TableCell>
                <TableCell className="custom-table-head">
                  Pressure (psi)
                </TableCell>
                <TableCell className="custom-table-head">Temp (°C)</TableCell>
                <TableCell className="custom-table-head">pH</TableCell>
                <TableCell className="custom-table-head">
                  Recovery (%)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tabledata1.map((row, idx) => (
                <TableRow key={idx} className="custom-row">
                  <TableCell className="custom-table-head">
                    {row.product}
                  </TableCell>
                  <TableCell className="custom-table-head">
                    {row.flow}
                  </TableCell>
                  <TableCell className="custom-table-head">
                    {row.rejection}
                  </TableCell>
                  <TableCell className="custom-table-head">
                    {row.naCl}
                  </TableCell>
                  <TableCell className="custom-table-head">
                    {row.pressure}
                  </TableCell>
                  <TableCell className="custom-table-head">
                    {row.temp}
                  </TableCell>
                  <TableCell className="custom-table-head">{row.pH}</TableCell>
                  <TableCell className="custom-table-head" >
                    {row.recovery}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div className="feature-icon">
            <img src={LedIcon} alt="" />
            <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" />
            <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" />
            <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col>
          <img src={Hydromatic_1} className="hydromatic-img img-fluid" alt="" />
        </Col>
      </Row>,
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs lg="6">
          <h4>RO MEMBRANE</h4>
          <h2 className="slider-head">Hydromatic</h2>
          <p>Industrial RO MEMBRANE</p>
          <ul>
            <li>Performs efficiently up to 5000 TDS</li>
            <li>Designed for high-demand industrial use</li>
            <li>High rejection, long membrane life</li>
            <li>Reliable under extreme water conditions</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" />
            <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" />
            <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" />
            <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col>
          <img src={Hydromatic_2} className="hydromatic-img img-fluid" alt="" />
        </Col>
      </Row>,
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs lg="6">
          <h4>RO MEMBRANE</h4>
          <h2 className="slider-head">Vontron</h2>
          <p>Domestic RO Membrance</p>
          <ul>
            <li>Efficiently works up to 2500 TDS.</li>
            <li>Specially made for domestic RO systems.</li>
            <li>Ensures clean and safe drinking water at home.</li>
            <li>Delivers reliable performance in household usage.</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" />
            <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" />
            <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" />
            <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col>
          <img src={Vontron_1Image} className="hydromatic-img img-fluid" alt="" />
        </Col>
      </Row>,
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs lg="6">
          <h4>RO MEMBRANE</h4>
          <h2 className="slider-head">Vontron</h2>
          <p>Industria RO Membrance</p>
          <ul>
            <li>Expert in brackish water desalination.</li>
            <li>Works efficiently up to 5000 TDS.</li>
            <li>Features high desalination capability.</li>
            <li>Built with advanced precision rolling technology.</li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" />
            <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" />
            <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" />
            <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col>
          <img src={Vontron_2Image} className="hydromatic-img img-fluid" alt="" />
        </Col>
      </Row>,
      <Row className="flex-column-reverse flex-lg-row">
        <Col xs lg="6">
          <h4>RO MEMBRANE</h4>
          <h2 className="slider-head">Vontron</h2>
          <p>PRO 80 Membrane</p>
          <ul>
            <li>Engineered to deliver a very good lifespan.</li>
            <li>Offers better quality and reliability.</li>
            <li>Delivers the highest recovery ratio.</li>
            <li>Ensures better overall performance.</li>
            <li>A quality Performance that makes sure that it will bring out the best in you & have the besr part </li>
          </ul>
          <div className="feature-icon">
            <img src={LedIcon} alt="" />
            <p>Digital LED Display</p>
            <img src={BoostIcon} alt="" />
            <p>Boost Immunity</p>
            <img src={CopperIcon} alt="" />
            <p>Copper Essentials Minerals</p>
          </div>
        </Col>
        <Col>
          <img src={Vontron_3Image} className="hydromatic-img img-fluid" alt="" />
        </Col>
      </Row>,
    ];
    return <ReusableSlider data={slides} className="section3-slider" />;
  };

  const Section4 = () => {
    const slides = [
      <Row>
        <Col>
          <div className="testimonial">
            <p>We've worked with them for over three years and have seen firsthand their commitment to quality, innovation, and customer satisfaction. From domestic RO components to large-scale solutions, their offerings are dependable and backed by a knowledgeable team.</p>
            <div className="testi-info">
              <img src={TestiProfile1} alt="" className="img-fluid" />
              <div>
                <h3>A company that truly understands water purification.</h3>
                <p>Happy Customer</p>
              </div>
            </div>
          </div>
        </Col>
      </Row>,
      <Row>
        <Col>
          <div className="testimonial">
            <p>What sets them apart is not just the product quality, but their deep industry understanding and professional approach. Every interaction—from consultation to delivery—has been seamless. It's rare to find a company so consistent and reliable.</p>
            <div className="testi-info">
              <img src={TestiProfile1} alt="" className="img-fluid" />
              <div>
                <h3>Trustworthy, experienced, and easy to work with.</h3>
                <p>Happy Customer</p>
              </div>
            </div>
          </div>
        </Col>
      </Row>,
      <Row>
        <Col>
          <div className="testimonial">
            <p>Their expertise in water purification is unmatched. We’ve sourced both domestic and industrial RO components from them, and every product has been delivered as promised. Support is prompt, and the team is proactive and committed.</p>
            <div className="testi-info">
              <img src={TestiProfile1} alt="" className="img-fluid" />
              <div>
                <h3>End-to-end excellence in everything they do.</h3>
                <p>Happy Customer</p>
              </div>
            </div>
          </div>
        </Col>
      </Row>,
    ];
    return <ReusableSlider data={slides} className="section4-slider" />;
  };

  const tabledata1 = [
    {
      product: "HD-1812-75",
      flow: 75,
      rejection: 98,
      naCl: 250,
      pressure: 60,
      temp: 25,
      pH: "6 - 8",
      recovery: 15,
    },
    {
      product: "HD-1812-80",
      flow: 80,
      rejection: 98,
      naCl: 250,
      pressure: 60,
      temp: 25,
      pH: "6 - 8",
      recovery: 15,
    },
    {
      product: "HD-2012-100",
      flow: 100,
      rejection: 98,
      naCl: 250,
      pressure: 60,
      temp: 25,
      pH: "6 - 8",
      recovery: 15,
    },
    {
      product: "HD-3012-300",
      flow: 300,
      rejection: 98,
      naCl: 250,
      pressure: 70,
      temp: 25,
      pH: "6 - 8",
      recovery: 15,
    },
  ];

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [values, setValues] = React.useState("eliza");

  const handleChange2 = (event, newValues) => {
    setValues(newValues);
  };
  const [pump, setPump] = React.useState("flowsy");

  const handleChange3 = (event, newpump) => {
    setPump(newpump);
  };

  const [membrane, setMembrane] = React.useState("hydrometic1");

  const handleChange4 = (event, newmembrane) => {
    setMembrane(newmembrane);
  };


  const data2 = {
    tab1: [
      {
        image: Bodeer,
        title: "Bodeer",
        content:
          "High-quality quick fittings engineered for leak-proof performance and easy installation. Compatible with a wide range of RO systems, Bodeer fittings ensure secure, durable connections. Perfect for maintaining optimal flow and system efficiency.",
      },
      {
        image: Washable,
        title: "Washable PVDF",
        content:
          "Reusable PVDF filter elements are designed for long-term performance and reduced replacement costs. It offers excellent chemical resistance and consistent filtration in both domestic and industrial setups. An eco-friendly solution for sustainable water purification. ",
      },
      {
        image: Antiscalant,
        title: "Antiscalant Balls",
        content:
          "Prevents scale formation and protects RO membranes, extending system life and efficiency.Ideal for areas with hard water, ensuring smooth operation and consistent output. A cost-effective, low-maintenance solution for cleaner, safer water.",
      },
      {
        image: QuickImage,
        title: "Quick Fitting",
        content: "Quick fittings are high-quality push-fit connectors that simplify RO installation. They provide a tight, leak-proof seal between pipes, allowing for smooth water flow and easy maintenance. Widely used in domestic and commercial systems, they’re built for convenience and reliability.",
      },
      {
        image: FlowRestictor,
        title: "Flow Restictor",
        content: "A flow restrictor is a vital component that controls the reject water flow from the RO membrane. It maintains the correct pressure across the membrane, improves purification efficiency, and reduces water wastage, ensuring optimal system performance and longer membrane life.",
      },
      {
        image: MembranceHousingImg,
        title: "Membrane Housing",
        content: "Membrane housing is designed to securely encase the RO membrane, ensuring leak-proof performance under high pressure. Made from durable, food-grade plastic, it offers safe water contact and long-lasting reliability. It's universally compatible with standard RO membranes and ensures smooth, uninterrupted flow.",
      },
      {
        image: PrefilterImages,
        title: "Pre-filter Housing",
        content: "TS, BBB, and AAA pre-filter sets effectively remove dust, rust, and sediments before RO filtration. They’re built for durability, smooth flow, and longer membrane life are perfectly designed for reliable, long-lasting performance in any RO system.",
      }
    ],
    tab2: [
      {
        image: QuickImage,
        title: "Quick Fitting",
        content: "Quick fittings are high-quality push-fit connectors that simplify RO installation. They provide a tight, leak-proof seal between pipes, allowing for smooth water flow and easy maintenance. Widely used in domestic and commercial systems, they’re built for convenience and reliability.",
      },
      {
        image: Bodeer,
        title: "Bodeer",
        content: "High-quality quick fittings engineered for leak-proof performance and easy installation. Compatible with a wide range of RO systems, Bodeer fittings ensure secure, durable connections. Perfect for maintaining optimal flow and system efficiency.",
      },
      {
        image: Washable,
        title: "Washable PVDF",
        content: "Reusable PVDF filter elements are designed for long-term performance and reduced replacement costs. It offers excellent chemical resistance and consistent filtration in both domestic and industrial setups. An eco-friendly solution for sustainable water purification. ",
      },
      {
        image: FlowRestictor,
        title: "Flow Restictor",
        content: "A flow restrictor is a vital component that controls the reject water flow from the RO membrane. It maintains the correct pressure across the membrane, improves purification efficiency, and reduces water wastage, ensuring optimal system performance and longer membrane life.",
      },
      {
        image: Antiscalant,
        title: "Antiscalant Balls",
        content: "Prevents scale formation and protects RO membranes, extending system life and efficiency.Ideal for areas with hard water, ensuring smooth operation and consistent output. A cost-effective, low-maintenance solution for cleaner, safer water. ",
      },
      {
        image: Housing,
        title: "Housing",
        content: "RO filter housing serves as a protective casing for components like pre-filters or carbon filters. Made from sturdy material, it safeguards internal parts while ensuring proper filtration flow. It’s built for strength, durability, and compatibility with most domestic RO units.",
      },
    ],
    tab3: [
      {
        image: MembranceHousingImg,
        title: "Membrane Housing",
        content: "Membrane housing is designed to securely encase the RO membrane, ensuring leak-proof performance under high pressure. Made from durable, food-grade plastic, it offers safe water contact and long-lasting reliability. It's universally compatible with standard RO membranes and ensures smooth, uninterrupted flow.",
      }

    ],
    tab4: [
      {
        image: PrefilterImages,
        title: "Pre-filter Housing",
        content: "TS, BBB, and AAA pre-filter sets effectively remove dust, rust, and sediments before RO filtration. They’re built for durability, smooth flow, and longer membrane life are perfectly designed for reliable, long-lasting performance in any RO system.",
      },
    ],
  };

  return (
    <>
      <header>
        <div className="container-warpper">
          <Navbar collapseOnSelect expand="lg" className="justify-content-between">

            <Navbar.Brand href="#home">
              <img src={Logo} alt="logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ms-auto">
                {/* <Nav.Link href="#about">About</Nav.Link> */}
                <Nav.Link href="#ro-system" className="pd">RO Systems</Nav.Link>
                <Nav.Link href="#pumps" className="pd">Pumps</Nav.Link>
                <Nav.Link href="#ro-membranes" className="pd">RO Membranes</Nav.Link>
                <Nav.Link href="#ro-assesories" className="pd">
                  {" "}
                  RO Accessories & Components
                </Nav.Link>
                <Nav.Link href="#contact" className="conatct-us-btn">
                  {" "}
                  Contact
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          {/* <Navbar data-bs-theme="light" className="justify-content-between">
            <Navbar.Brand href="#home">
              <img src={Logo} alt="logo" />
            </Navbar.Brand>
            <Navbar.Collapse className="justify-content-end">
              <Navbar.Text>
                <Nav>
                  <Nav.Link href="#about">About</Nav.Link>
                  <Nav.Link href="#ro-system">RO Systems</Nav.Link>
                  <Nav.Link href="#pums">Pumps</Nav.Link>
                  <Nav.Link href="#ro-membranes">RO Membranes</Nav.Link>
                  <Nav.Link href="#ro-assesories">
                    {" "}
                    RO Accessories & Components
                  </Nav.Link>
                  <Nav.Link href="#contact" className="conatct-us-btn">
                    {" "}
                    Contact
                  </Nav.Link>
                </Nav>
              </Navbar.Text>
            </Navbar.Collapse>
          </Navbar> */}
        </div>
      </header>
      <main>
        <section className="banner-section">
          <div className="container-warpper">
            <Row className="position-relative">
              <Col xs="12" lg="9">
                <h1>Purity in Every Drop of Water</h1>
                <p>
                  Experience cutting-edge RO technology designed for purity,
                  efficiency, and sustainability. Our advanced filtration
                  solutions ensure safe and healthy water for homes, businesses,
                  and industries. Upgrade to smarter, cleaner water today!{" "}
                </p>
              </Col>
              <Col xs lg="3">
                <a href="#ro-system" className="explore-circle">
                  <div className="explore-text">
                    <svg viewBox="0 0 100 100">
                      <path
                        id="curve"
                        d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"
                        fill="transparent"
                      ></path>
                      <text className="circle-text">
                        <textPath href="#curve">
                          Explore More Explore More &nbsp;
                        </textPath>
                      </text>
                    </svg>
                  </div>
                  <div className="explore-arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="85"
                      height="85"
                      viewBox="0 0 85 85"
                      fill="none"
                    >
                      <path
                        d="M42.1953 74.1997V11.1997M42.1953 74.1997L17.6953 49.6997M42.1953 74.1997L66.6953 49.6997"
                        stroke="#0057A4"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </a>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="main-banner">
                  <div className="logo-wrapper">
                    <div>
                      <img src={NileLogo} alt="" className="img-fluid client-logo" />
                    </div>
                    <div>
                      <img src={ZuanliLogo} alt="" className="img-fluid client-logo" />
                    </div>
                    <div>
                      <img src={EquroxLogo} alt="" className="img-fluid client-logo" />
                    </div>
                    <div>
                      <img src={VontronLogo} alt="" className="img-fluid client-logo" />
                    </div>
                    <div>
                      <img src={FlowsyLogo} alt="" className="img-fluid client-logo" />
                    </div>
                    <div>
                      <img src={HydromaticLogo} alt="" className="img-fluid client-logo" />
                    </div>
                  </div>
                  <div className="banner-img">
                    <img src={MainBanner_2} alt="" className="img-fluid" />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </section>
        <section className="form-wrapper" id="contact">
          <div className="container-warpper">
            <Row>
              <Col xs="12" lg="5">
                <h4>Request a Quote</h4>
                <h2>Find Your Perfect RO Solution</h2>
                <p>
                  Choosing the right water purifier isn’t just about features, it’s about trust, reliability, and long-term peace of mind. With deep-rooted expertise and a strong commitment to quality, our solutions are designed to deliver safe, efficient, and sustainable purification for every space. Whether for your home, workplace, or larger facility, find the RO system that meets your needs perfectly, and without compromise.
                </p>
              </Col>
              <Col xs="12" lg="7">
                <div className="form-right">
                  <form>
                    <FormControl
                      className="custom-formctr inputwrapper"
                      defaultValue=""
                      required
                    >
                      <p>Full Name* :</p>
                      <BorderedInput
                        className="custom-input"
                        aria-label="Demo input"
                        placeholder="Enter your Full name"
                      />
                    </FormControl>
                    <FormControl
                      className="custom-formctr inputwrapper"
                      defaultValue=""
                      required
                    >
                      <p>Email* :</p>
                      <BorderedInput
                        type="email"
                        className="custom-input"
                        aria-label="Demo input"
                        placeholder="Enter Email Address"
                      />
                    </FormControl>
                    <FormControl
                      className="custom-formctr inputwrapper"
                      defaultValue=""
                      required
                    >
                      <p>Phone Number* :</p>
                      <BorderedInput
                        aria-label="Demo input"
                        className="custom-input"
                        placeholder="Enter Phone Number"
                      />
                    </FormControl>
                    <FormControl
                      className="custom-formctr inputwrapper"
                      defaultValue=""
                      required
                    >
                      <p>City*</p>
                      <BorderedInput
                        type="email"
                        aria-label="Demo input"
                        className="custom-input"
                        placeholder="City"
                      />
                    </FormControl>
                    <div className="full-width-inputs">
                      <p>Select Product * :</p>

                      <Select
                        placeholder="Select a products"
                        indicator={<KeyboardArrowDown />}
                        className="custom-select me-3"
                      >
                        <Option value="dog">Ro Systems</Option>
                        <Option value="cat">Pumps</Option>
                        <Option value="fish">Ro Membrance</Option>
                      </Select>
                    </div>
                    <div className="full-width-inputs">
                      <p className="">Message:</p>
                      <Textarea
                        className="custom-input-last"
                        minRows={2}
                        name="Size"
                        placeholder="Medium"
                      />
                    </div>
                    <div className="full-width-inputs">
                      <Button
                        className="custom-btn"
                        sx={{
                          padding: {
                            md: "14px 28px;", // desktop
                          },
                          fontSize: {
                            md: "18px",
                          },
                          marginTop: { md: "22px" },
                        }}
                      >
                        Send Message
                      </Button>
                    </div>
                  </form>
                </div>
              </Col>
            </Row>
          </div>
        </section>


        <section id="ro-system">
          <div className="ro-systems d-none d-md-block" >
            <div className="container-warpper">
              <Section1 />
            </div>
          </div>
          <div className="mobile-tabs d-block d-md-none py-0">
            <div className="container-warpper">
              <TabContext value={values}>
                <Box
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                  className="custom-box"
                >
                  <TabList
                    onChange={handleChange2}
                    aria-label="lab API tabs example"
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    <Tab label="AQUA Eliza" value="eliza" />
                    <Tab label="AQUA Strom" value="strom" />
                    <Tab label="AQUA Innovica" value="innovica" />
                    <Tab label="AQUA 2090" value="townine" />
                    <Tab label="AQUA Mars" value="mars" />
                    <Tab label="AQUA Nine" value="nine" />
                  </TabList>
                </Box>
                <TabPanel value="eliza">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs="12" lg="5">
                      <h4>RO Systems</h4>
                      <h2 className="slider-head">AQUA Eliza</h2>
                      <ul>
                        <li>For Counter Top / Wall Mounting</li>
                        <li>Purification : RO + UV + Alkaline + Copper + TDS (Optional)</li>
                        <li>Digital Display</li>
                        <li>Food Grade, Non Breakable, ABS Plastic Construction</li>
                        <li>Purification Capacity of 12 to 15 Ltr. / hr.</li>
                        <li>Tank Storage Capacity : 10 Ltr. (Approx)</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col xs="12" lg="7">
                      <img src={AquaImage} alt="" className="img-fluid product-images" />
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="strom">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs="12" lg="5">
                      <h4>RO Systems</h4>
                      <h2 className="slider-head">AQUA Strom</h2>
                      <ul>
                        <li>High-flow purification system ideal for larger families.</li>
                        <li>Advanced TDS controller for balanced mineral retention.</li>
                        <li>Durable body with wall-mount or countertop flexibility.</li>
                        <li>Ensures purity with every drop, even in high TDS regions.</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col xs="12" lg="7">
                      <img src={StromImage} alt="" className="img-fluid product-images" />
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="innovica">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs="12" lg="5">
                      <h4>RO Systems</h4>
                      <h2 className="slider-head">AQUA Innovica</h2>
                      <ul>
                        <li>Sleek and compact, perfect for urban kitchens.</li>
                        <li>Smart LED indicators for filter status and maintenance alerts.</li>
                        <li>Energy-efficient design with optimum purification performance.</li>
                        <li>Designed for low-water wastage and maximum purity.</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col xs="12" lg="7">
                      <img src={innovicaImage} alt="" className="img-fluid product-images" />
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="townine">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs="12" lg="5">
                      <h4>RO Systems</h4>
                      <h2 className="slider-head">AQUA 2090</h2>
                      <ul>
                        <li>Heavy-duty RO system for homes with high water consumption.</li>
                        <li>Multiple purification stages for comprehensive filtration.</li>
                        <li>High-capacity storage tank with quick recovery rate.</li>
                        <li>Advanced RO technology with Copper + Alkaline filtration for pure & mineral-rich water.</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col xs="12" lg="7">
                      <img src={Aqua2Image} alt="" className="img-fluid product-images" />
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="mars">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs="12" lg="5">
                      <h4>RO Systems</h4>
                      <h2 className="slider-head">AQUA Mars</h2>
                      <ul>
                        <li>Combines style with superior purification technology.</li>
                        <li>Retains essential minerals with advanced TDS regulation.</li>
                        <li>Safe for borewell, tanker, and municipal water sources.</li>
                        <li>Ideal for both residential and light commercial use.</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col xs="12" lg="7">
                      <img src={MarseImage} alt="" className="img-fluid product-images" />
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="nine">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs="12" lg="5">
                      <h4>RO Systems</h4>
                      <h2 className="slider-head">AQUA Nine</h2>
                      <ul>
                        <li>Compact and robust design with smart purification layers.</li>
                        <li>Delivers safe, odor-free, and great-tasting water.</li>
                        <li>Built-in pre-filter and mineral enhancer functionality.</li>
                        <li>Reliable choice for everyday healthy hydration. </li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col xs="12" lg="7">
                      <img src={NineImage} alt="" className="img-fluid product-images" />
                    </Col>
                  </Row>
                </TabPanel>
              </TabContext>
            </div>
          </div>
        </section>

        <section id="pumps">
          <div className="diaphragm-pump d-none d-md-block">
            <div className="container-warpper">
              <Section2 />
            </div>
          </div>
          <div className="mobile-tabs d-block d-md-none py-0" >
            <div className="container-warpper">
              <TabContext value={pump}>
                <Box
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                  className="custom-box"
                >
                  <TabList
                    onChange={handleChange3}
                    aria-label="lab API tabs example"
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    <Tab label="Flowsy" value="flowsy" />
                    <Tab label="EQUROX" value="equrox" />
                    <Tab label="VERTEX" value="vertex" />
                    <Tab label="ZUANLI" value="zuanli" />
                  </TabList>
                </Box>
                <TabPanel value="flowsy">
                  <Row >
                    <Col>
                      <img src={FlowsyImage} alt="" className="flosy-img img-fluid product-images" />
                    </Col>
                    <Col xs="12" lg="5">
                      <h4>DIAPHRAGM PUMP</h4>
                      <h2 className="slider-head">Flowsy</h2>
                      <ul>
                        <li>Ideal for 75 GPD domestic RO systems.</li>
                        <li>Provides stable and silent performance.</li>
                        <li>Features low heat generation for extended lifespan.</li>
                        <li>Compact and energy-efficient design with high reliability.</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" className="img-fluid" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" className="img-fluid" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" className="img-fluid" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="equrox">
                  <Row >
                    <Col xs="12" lg="7">
                      <img src={EquroxImage} className="flosy-img img-fluid product-images" alt="" />
                    </Col>
                    <Col xs="12" lg="5">
                      <h4>DIAPHRAGM PUMP</h4>
                      <h2 className="slider-head">EQUROX</h2>
                      <ul>
                        <li>Operates with zero noise for a silent experience.</li>
                        <li>Provides excellent and stable pressure output.</li>
                        <li>Engineered for the lowest vibration during use.</li>
                        <li>Generates minimal heat for better efficiency.</li>
                        <li>Built for long-lasting, reliable performance.</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="vertex">
                  <Row >
                    <Col xs="12" lg="7">
                      <img src={VertexImage} className="flosy-img img-fluid product-images" alt="" />
                    </Col>
                    <Col xs="12" lg="5">
                      <h4>DIAPHRAGM PUMP</h4>
                      <h2 className="slider-head">VERTEX</h2>
                      <ul>
                        <li>India’s First Low-Budget Imported Pump</li>
                        <li>18-Month Piece-to-Piece Warranty</li>
                        <li>100 GPD Flow Capacity</li>
                        <li>Minimal Heat Generation</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="zuanli">
                  <Row >
                    <Col xs="12" lg="7">
                      <img src={Zunli} className="flosy-img img-fluid product-images" alt="" />
                    </Col>
                    <Col xs="12" lg="5">
                      <h4>DIAPHRAGM PUMP</h4>
                      <h2 className="slider-head">ZUANLI</h2>
                      <ul>
                        <li>Trusted imported pump with consistent pressure output</li>
                        <li>Designed for low noise and minimal vibration operation</li>
                        <li>Built for long-term durability in residential RO systems</li>
                        <li>Efficient 24V DC performance with stable flow control</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" /> <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" /> <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" /> <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                  </Row>
                </TabPanel>
              </TabContext>
            </div>
          </div>
        </section>

        <section id="ro-membranes">
          <div className="ro-membrance d-none d-md-block">
            <div className="container-warpper">
              <Section3 />
            </div>
          </div>
          <div className="mobile-tabs d-block d-md-none py-0" id="ro-membranes">
            <div className="container-warpper">
              <TabContext value={membrane}>
                <Box
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                  className="custom-box"
                >
                  <TabList
                    onChange={handleChange4}
                    aria-label="lab API tabs example"
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    <Tab label="Hydrometic(75/80/100/300 GPD)" value="hydrometic1" />
                    <Tab label="Hydromatic(Industrial )" value="hydrometic2" />
                    <Tab label="Vontron(Domestic)" value="vontron1" />
                    <Tab label="Vontron(Industrial)" value="vontron2" />
                    <Tab label="Vontron(PRO 80)" value="vontron3" />
                  </TabList>
                </Box>
                <TabPanel value="hydrometic1">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs lg="6">
                      <h4>RO MEMBRANE</h4>
                      <h2 className="slider-head">Hydromatic</h2>
                      <p>75/80/100/300 GPD</p>
                      <ul>
                        <li>High TDS Compatibility.</li>
                        <li>Premium Filtration Efficiency.</li>
                        <li>Multiple Flow Capacities.</li>
                        <li>Reliable & Long-Lasting.</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" />
                        <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" />
                        <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" />
                        <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col>
                      <img src={Hydromatic_1} className="hydromatic-img img-fluid" alt="" />
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="hydrometic2">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs lg="6">
                      <h4>RO MEMBRANE</h4>
                      <h2 className="slider-head">Hydromatic</h2>
                      <p>Industrial RO MEMBRANE</p>
                      <ul>
                        <li>Performs efficiently up to 5000 TDS</li>
                        <li>Designed for high-demand industrial use</li>
                        <li>High rejection, long membrane life</li>
                        <li>Reliable under extreme water conditions</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" />
                        <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" />
                        <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" />
                        <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col>
                      <img src={Hydromatic_2} className="hydromatic-img img-fluid" alt="" />
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="vontron1">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs lg="6">
                      <h4>RO MEMBRANE</h4>
                      <h2 className="slider-head">Vontron</h2>
                      <p>Domestic RO Membrance</p>
                      <ul>
                        <li>Efficiently works up to 2500 TDS.</li>
                        <li>Specially made for domestic RO systems.</li>
                        <li>Ensures clean and safe drinking water at home.</li>
                        <li>Delivers reliable performance in household usage.</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" />
                        <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" />
                        <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" />
                        <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col>
                      <img src={Vontron_1Image} className="hydromatic-img img-fluid" alt="" />
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="vontron2">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs lg="6">
                      <h4>RO MEMBRANE</h4>
                      <h2 className="slider-head">Vontron</h2>
                      <p>Industria RO Membrance</p>
                      <ul>
                        <li>Expert in brackish water desalination.</li>
                        <li>Works efficiently up to 5000 TDS.</li>
                        <li>Features high desalination capability.</li>
                        <li>Built with advanced precision rolling technology.</li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" />
                        <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" />
                        <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" />
                        <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col>
                      <img src={Vontron_2Image} className="hydromatic-img img-fluid" alt="" />
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel value="vontron3">
                  <Row className="flex-column-reverse flex-lg-row">
                    <Col xs lg="6">
                      <h4>RO MEMBRANE</h4>
                      <h2 className="slider-head">Vontron</h2>
                      <p>PRO 80 Membrane</p>
                      <ul>
                        <li>Engineered to deliver a very good lifespan.</li>
                        <li>Offers better quality and reliability.</li>
                        <li>Delivers the highest recovery ratio.</li>
                        <li>Ensures better overall performance.</li>
                        <li>A quality Performance that makes sure that it will bring out the best in you & have the besr part </li>
                      </ul>
                      <div className="feature-icon">
                        <img src={LedIcon} alt="" />
                        <p>Digital LED Display</p>
                      </div>
                      <div className="feature-icon">
                        <img src={BoostIcon} alt="" />
                        <p>Boost Immunity</p>
                      </div>
                      <div className="feature-icon">
                        <img src={CopperIcon} alt="" />
                        <p>Copper Essentials Minerals</p>
                      </div>
                    </Col>
                    <Col>
                      <img src={Vontron_3Image} className="hydromatic-img img-fluid" alt="" />
                    </Col>
                  </Row>
                </TabPanel>
              </TabContext>
            </div>
          </div>
        </section>

        <section className="custom-tab-wrapper" id="ro-assesories">
          <div className="container-warpper">
            <h4 className="text-center">Extend Your RO System’s Life</h4>
            <h2 className="text-center">RO Accessories & Components</h2>
            <TabContext value={value}>
              <Box
                sx={{ borderBottom: 1, borderColor: "divider" }}
                className="custom-box"
              >
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label="All Products" value="1" />
                  <Tab label="Import Products" value="2" />
                  <Tab label="Membrane Housing" value="3" />
                  <Tab label="Pre-Filter Housing" value="4" />
                </TabList>
              </Box>
              <TabPanel value="1">
                <Reusablemulti items={data2.tab1} />
              </TabPanel>
              <TabPanel value="2">
                <Reusablemulti items={data2.tab2} />
              </TabPanel>
              <TabPanel value="3">
                <Reusablemulti items={data2.tab3} />
              </TabPanel>
              <TabPanel value="4">
                <Reusablemulti items={data2.tab4} />
              </TabPanel>
            </TabContext>
          </div>
        </section>
        <section className="testi-wrapper">
          <div className="container-warpper">
            <h4 className="text-center">Trusted by homeowners, businesses, and industries</h4>
            <h2 className="text-center">What Our Customers Say About Us</h2>
            <Section4 />
          </div>
        </section>
        <section className="faq-wrapper">
          <div className="container-warpper">
            <Row className="custom-faq-row">
              <Col xs="12" lg="4">
                <div className="faq-disc">
                  <h4>Got Questions?</h4>
                  <h2>We’ve Got Answers!</h2>
                  <p>Understanding water purification can be complex, but we’re here to make it simple! Explore our frequently asked questions to learn more about installation, maintenance, product compatibility, and how our advanced RO systems can enhance your water quality</p>
                </div>
              </Col>
              <Col xs="12" lg="7">
                <div className="accordian-wrapper">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0" className="custom-button">
                      <Accordion.Header className="custom-header" >What does your company specialize in?</Accordion.Header>
                      <Accordion.Body className="custom-body">
                        We specialize in advanced water purification solutions for both domestic and industrial use. Our offerings range from RO systems and membranes to customized treatment plants and accessories, ensuring safe, pure, and efficient water at every level.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1" className="custom-button">
                      <Accordion.Header className="custom-header">Are your products suitable for high TDS and industrial applications?</Accordion.Header>
                      <Accordion.Body className="custom-body">
                        Yes, our RO membranes and purification systems are engineered to perform efficiently even in high TDS conditions (up to 5000 ppm), making them ideal for industrial, commercial, and challenging water conditions.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2" className="custom-button">
                      <Accordion.Header className="custom-header">Do you manufacture your own products?</Accordion.Header>
                      <Accordion.Body className="custom-body">
                        Yes, we proudly manufacture a wide range of RO components and systems under the Make in India initiative. We also import and distribute globally trusted brands like Vontron and Zuanli to ensure access to top-quality international products.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3" className="custom-button">
                      <Accordion.Header className="custom-header">Who can buy your products: only businesses or individuals?</Accordion.Header>
                      <Accordion.Body className="custom-body">
                        Our products are available to both individuals and businesses. Whether you need RO components for home use or large-scale systems for industrial operations, we cater to a wide spectrum of customers through B2B and B2C channels.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4" className="custom-button">
                      <Accordion.Header className="custom-header">Do you provide customized water treatment solutions?</Accordion.Header>
                      <Accordion.Body className="custom-body">
                        Absolutely. We offer tailored solutions for industrial water treatment needs, including STP, ETP, WTP, water softeners, and more, designed to meet your specific quality, scale, and regulatory requirements.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5" className="custom-button">
                      <Accordion.Header className="custom-header">Do you offer international shipping or export services?</Accordion.Header>
                      <Accordion.Body className="custom-body">
                        Yes, we export our RO components and water purification products to several international markets, with a growing global presence built on quality, consistency, and customer trust.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Col>
            </Row>
          </div>
        </section>
      </main>
      <footer className="footer-wrapper">
        <div className="footer-info">
          <img src={ReverseLogo} alt="" className="reverse-logo img-fluid" />
          <div className="email-phone">
            <p><a href="mailto:info@cloudwater.in" target="_blank"><span><EmailOutlinedIcon /></span>info@cloudwater.in</a></p>
            <p><a href="tel:+919825944828" target="_blank"><span><PhoneOutlinedIcon /></span>+91 98259 44828</a></p>
          </div>
          <div className="address">
            <p><a href="https://maps.app.goo.gl/Eoe7GFU1nj9Soapp8" target="_blank"><span><LocationOnOutlinedIcon /></span>Cammy International LLP,
              Sanket industrial Eastate-1,
              Plot No.- 12A
              Sarkhej-Bavla road,
              Behind- Nova petrol pump
              Near water supplier
              OPP. HOF
              Moraiya - 382213, Ta. Sanand
              Dist. Ahmedabad</a></p>
          </div>



          <div>
            <p><span></span></p>
          </div>
        </div>
      </footer>


    </>
  );
}
export default App;
